import React from 'react'
import { Button } from '@/components/buttons/Button'
import { TextArea } from '@/components/forms/TextArea'
import { Pill } from '@/components/pills/Pill'
import { scoreToLabel } from '@/utils/promptFeedback.helpers'

function getScorePillProps(score) {
  if (score === 1) {
    return { success: true, outlined: true }
  }
  if (score === 0) {
    return { critical: true, outlined: true }
  }
  return { outlined: true }
}

export function CriteriaFeedbackBanner({
  criteriaId,
  criteriaUuid,
  originalAiScore,
  currentScore,
  feedbackValue,
  onFeedbackChange,
  onSkip,
}) {
  return (
    <div
      data-testid={`criteria-feedback-banner-${criteriaId}`}
      className="criteria-feedback-banner"
    >
      <div className="criteria-feedback-divider" />

      <div className="criteria-feedback-heading-row">
        <h3 className="criteria-feedback-heading">What should the AI have noticed?</h3>
        <Button text small onClick={onSkip}>
          Skip feedback
        </Button>
      </div>

      <p className="criteria-feedback-body">
        You changed this criteria from{' '}
        <Pill xs {...getScorePillProps(originalAiScore)} className="inline-flex">
          {scoreToLabel(originalAiScore)}
        </Pill>{' '}
        to{' '}
        <Pill xs {...getScorePillProps(currentScore)} className="inline-flex">
          {scoreToLabel(currentScore)}
        </Pill>
        . If you share what the AI missed, it helps make it more accurate in the future.
      </p>

      <div className="mbs">
        <TextArea
          data-testid={`criteria-feedback-textarea-${criteriaId}`}
          placeholder="E.g., The agent offered a discount but the AI didn't catch it..."
          value={feedbackValue || ''}
          onChange={(event) => onFeedbackChange(criteriaUuid, event.target.value || '')}
          onKeyDown={(event) => event.stopPropagation()}
          rows={3}
        />
      </div>

      <p className="muted-text criteria-feedback-helper">
        Optional. Your feedback will be submitted when you save the scores.
      </p>
    </div>
  )
}
